import { compactSymbolObject } from '@ota-frontend/core/utils'
import SearchCondition from './searchCondition'

export default class IntentionLp {
  constructor(intentionLp = {}) {
    this.intentionLp = intentionLp
  }

  get intentionId() {
    return this.intentionLp.intention_id
  }

  get image() {
    return {
      pc: this.intentionLp.image,
      sp: this.intentionLp.sp_image,
    }
  }

  get title() {
    return this.intentionLp.title
  }

  get description() {
    return this.intentionLp.description
  }

  get pickedUpIntentionIds() {
    return this.intentionLp.picked_up_intention_ids || []
  }

  get metaTitle() {
    return this.intentionLp.meta_title
  }

  get metaDescription() {
    return this.intentionLp.meta_description
  }

  applyDefaults(condition) {
    return (this.intentionId ? condition.selectIntention(this.intentionId.split('-')) : condition)
      .withDefaults(compactSymbolObject({
        [SearchCondition.PARAMS.DOMESTIC]: this.intentionLp.domestic,
        [SearchCondition.PARAMS.REGION_OF_DESTINATION1]: this.intentionLp.region_id,
        [SearchCondition.PARAMS.NUMBER_OF_PASSENGERS]: this.intentionLp.passenger_count,
        [SearchCondition.PARAMS.KEYWORD]: this.intentionLp.keyword,
      }))
  }
}
